module.exports = __webpack_public_path__ + "static/transparency_report2020@2x-92e0ed8986c54cb61f7f8281b54c55b9.png";